import { render, staticRenderFns } from "./ElementsTreeNodeSettingsPanel.vue?vue&type=template&id=12f3e470"
import script from "./ElementsTreeNodeSettingsPanel.vue?vue&type=script&lang=js"
export * from "./ElementsTreeNodeSettingsPanel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports